import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { RTL_LOCALES } from '@shared/constants.js';

export function RTLProvider({ children }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const dir = RTL_LOCALES.includes(i18n.language) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', i18n.language);
  }, [i18n.language]);

  return children;
}
